(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Symphonie);

	// Constructor
	function Symphonie() {

		// Super constructor
		BaseGame.call(this);

		// Overide audio click sound
		// this.clickSound = "audiojungle-20134560-cheeping-frog.wav";
		this.clickSound = false;

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = false;

		this.screenSaverCounter = 0;
		this.screenSaverAudios = [];

		// this.draggable = false;

		this.user = {
			currentQuestionSet: "",
			currentQuestion: -1,
			questionsCount: 0,
			score: 0
		}

		// Load data then init
		this.loadData();
	}

	Symphonie.prototype.loadData = function () {

		// Load JSON
		$.ajax({
			url: "data/symphonie.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		}).promise().then($.proxy(function () {
			this.initGame();
		}, this));
	};

	Symphonie.prototype.initGame = function () {

		// Copy screen 5 into screen 9
		$("#screen-9").html($("#screen-5").html());

		// Copy screen 6 into screen 10
		$("#screen-10").html($("#screen-6").html());

		// Create credits page
		var credits = [];
		$.each(this.data.animals, function (i, n) {
			if (n.img) {
				credits.push({
					img: n.img,
					label: n.img_credit
				});
			}
		});
		BaseGame.prototype.createCredits.call(this, credits);

		// Go to first screen
		this.goToScreen(1);
		// this.goToScreen(4);
		// this.goToScreen(7);
		// this.goToScreen(11);
	};

	Symphonie.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		// Stop currently playing sound
		this.audio.stop();

		// On specific screens, make specific actions
		if (screenId == 1) {
			this.startScreenSaverAudio();
		} else if (screenId == 2) {
			this.stopScreenSaverAudio();
		} else if (screenId == 5 || screenId == 9) {
			this.user.currentQuestion = -1;
			this.user.score = 0;
			this.user.currentQuestionSet = $("#screen-" + screenId).data("questions-set");
			this.user.questionsCount = 0;
			this.gameChoicesNextQuestion($("#screen-" + screenId));
		} else if (screenId == 6 || screenId == 10) {
			this.buildScoreScreen($("#screen-" + screenId));
		}
	}

	Symphonie.prototype.startScreenSaverAudio = function () {

		// Init audio list and shuffle it
		this.screenSaverCounter = 0;
		this.screenSaverAudios = [];
		$.each(this.data["animals"], $.proxy(function (i, n) {
			this.screenSaverAudios.push(n["audio"]);
		}, this));
		this.screenSaverAudios = shuffle(this.screenSaverAudios);

		// Loop through audio elements
		$(".screensaver-audio").each($.proxy(function (i, audioEl) {

			// Set source
			this.screenSaverSetSource(audioEl);

			// Set new source on ended
			$(audioEl).on('ended', $.proxy(function (i, audioEl) {
				this.screenSaverSetSource(audioEl);
			}, this, i, audioEl));

		}, this));
	}

	Symphonie.prototype.screenSaverSetSource = function (audioEl) {
		var audioSrc = "audio/" + this.screenSaverAudios[this.screenSaverCounter];
		audioEl.src = "";
		audioEl.load();
		audioEl.src = audioSrc;
		audioEl.volume = 0.6;
		audioEl.load();
		console.log("new src : " + audioSrc)
		this.screenSaverCounter = (this.screenSaverCounter + 1) % this.screenSaverAudios.length;
	}

	Symphonie.prototype.stopScreenSaverAudio = function () {

		$(".screensaver-audio").each($.proxy(function (i, audioEl) {
			audioEl.src = "";
			audioEl.load();
		}, this));
	}

	Symphonie.prototype.gameChoicesNextQuestion = function ($el) {

		// Define currrent element to use (since there are multiple games in this interactive screen)
		if (typeof $el == "undefined") {
			$el = $("#screen-" + this.currentScreen);
		}

		// Set the question data
		var questionsData = this.data[this.user.currentQuestionSet];

		// Hide next button and reset things
		$el.find(".button.next").addClass("hidden");

		// Fade out current
		if (($el.find(".feedback-status").hasClass("wrong") || $el.find(".feedback-status").hasClass("right")) && ((this.user.currentQuestion + 1) < questionsData.length)) {
			$el.find(".game-choices-question").fadeOut("normal", $.proxy(function ($el) {
				this.resetGameChoiceQuestion($el);
				$el.find(".game-choices-question").fadeIn("normal");
				this.gameChoicesNextQuestion($el);
			}, this, $el));
			return;
		}

		// Increase current question
		this.user.currentQuestion++;

		// Allow user to go to next screen when we are at the end of questions list
		if (this.user.currentQuestion >= questionsData.length) {
			this.goToNextScreen(function () {
				$(".game-choices-question").removeClass("hidden");
				$(".game-choices-freedback").addClass("hidden");
			});
			return;
		}

		// Reset a few things
		this.resetGameChoiceQuestion($el);

		// Increase question count
		this.user.questionsCount++;

		// Set local variables
		var currentQuestion = questionsData[this.user.currentQuestion];
		var $gameWrapper = $el.find(".choices-wrapper");
		$gameWrapper.alterClass('question-*', 'question-' + this.user.currentQuestion);
		var $choicesWrapper = $el.find(".choices-wrapper");

		// Set choices
		$choicesWrapper.empty();
		var shuffledChoices = shuffle(currentQuestion.choices);
		$.each(shuffledChoices, $.proxy(function (i, c) {

			// Get current animal
			var animal = $(this.data["animals"]).filterByProperty('code', c)[0];

			// Create DON
			var $choice = $('<div />');
			$choice.addClass("choice").attr("data-answer", c).attr("data-position", (i + 1));
			var $choiceImg = $('<div class="image"><img /></div>');
			$choiceImg.find("img").attr("src", animal.img)
			$choice.append($choiceImg);
			$choicesWrapper.append($choice);

			// Set question
			var $animalName = $('<div class="animal-name" />');
			$animalName.addClass("i18n fading-i18n");
			$animalName.append('<span class="fr">' + animal.name.fr + '</span>');
			$animalName.append('<span class="en">' + animal.name.en + '</span>');
			$choice.append($animalName);

			var $animalInfos = $('<div class="animal-infos i18n fading-i18n"><span class="fr"/><span class="en"/></div>');
			$animalInfos.find('.fr').html(animal.activity_period.fr);
			$animalInfos.find('.en').html(animal.activity_period.en);
			$choice.append($animalInfos);

			// Bind action
			$choice.one("click", $.proxy(this.validateGameChoiceQuestion, this));

		}, this));

		// Bind tip trigger action
		$(".tip-trigger").on("click", $.proxy(this.showTip, this));

		// Set tip
		var $tipWrapper = $el.find(".tip-wrapper");
		$tipWrapper.find(".tip").remove();
		var $tip = $('<div class="tip"><div class="i18n fading-i18n"></div></div>');
		$tip.find(".i18n").append('<span class="fr">' + currentQuestion.tip.fr + '</span>');
		$tip.find(".i18n").append('<span class="en">' + currentQuestion.tip.en + '</span>');
		$tipWrapper.append($tip);

		// Set audio to play, and play it once
		var answerAnimal = $(this.data["animals"]).filterByProperty('code', currentQuestion.answer)[0];
		$el.find(".play-sound").data("audio", answerAnimal.audio);

		// Stop audio
		this.audio.stop();

		// Play sound after a small dealy to avoid glitch with click sound
		// requestTimeout($.proxy(function () {
		// this.audio.play(answerAnimal.audio);
		// }, this), 250);

		// On click, play sound
		$el.find(".play-sound").off("click").on("click", $.proxy(function (e) {
			this.audio.play($(e.currentTarget).data("audio"));
		}, this));
	}

	Symphonie.prototype.validateGameChoiceQuestion = function (e) {

		var $el = $("#screen-" + this.currentScreen);

		// Question data
		var questionsData = this.data[this.user.currentQuestionSet];
		var userAnswer = $(e.currentTarget).data("answer");
		var userAnswerPosition = $(e.currentTarget).data("position");
		var currentQuestion = questionsData[this.user.currentQuestion];

		// Show next buttton
		$el.find(".button.next").removeClass("hidden");

		// Remove click actions
		$el.find(".choices-wrapper .choice").off("click");

		// Find feedback element
		var $feedbackStatusWrapper = $el.find(".feedback-status");

		// Validate user answer
		if (userAnswer == currentQuestion.answer) {
			console.log("good");
			$feedbackStatusWrapper.alterClass("wrong choice-1 choice-2 choice-3", "right");

			// Update score
			// if ($(".tip-wrapper").hasClass("tip-shown")) {
			// 	this.user.score += 0.5;
			// } else {
			// 	this.user.score += 1;
			// }
			this.user.score += 1;

			// Play audio good sound
			// this.audio.play("audiojungle-20932244-owl-calling.wav");

		} else {
			console.log("wrong", userAnswer, "wrong choice-" + (userAnswer + 1));
			$feedbackStatusWrapper.alterClass("right choice-1 choice-2 choice-3", "wrong choice-" + (userAnswerPosition));

			// Play audio wrong sound
			// this.audio.play("audiojungle-20668144-fishing-fish-catching-with-net.wav");
		}

		// Stop audio
		this.audio.stop();

		// Hide tip and disable click
		this.hideTip();
		$(".tip-trigger").off("click");

		// Set highlight to correct answer
		$el.find(".choices-wrapper .choice").each(function (i, n) {
			if ($(n).data("answer") == currentQuestion.answer) {
				$(n).addClass("highlighted")
			} else {
				$(n).addClass("faded")
			}
		});

		// Show thumbs up/down
		$feedbackStatusWrapper.addClass("shown")

	}

	Symphonie.prototype.resetGameChoiceQuestion = function ($el) {
		$el.find(".feedback-status").removeClass("right wrong shown");
		$el.find(".choices-wrapper .choice").removeClass("highlighted faded")
		this.hideTip();
	}

	Symphonie.prototype.showTip = function (e) {
		$(e.currentTarget).parent(".tip-wrapper").addClass("tip-shown");
		this.audio.play("Click.wav");
	}

	Symphonie.prototype.hideTip = function (e) {
		$(".tip-wrapper").removeClass("tip-shown");
	}

	Symphonie.prototype.buildScoreScreen = function ($el) {

		// Remove current low/medium/high classes
		$el.removeClass("low medium high");

		// Display score
		$el.find(".dynamic-score").html(this.user.score.toString() + " / " + this.user.questionsCount)

		// Set normalized score
		var normalizedScore = this.user.score / this.user.questionsCount;
		if (normalizedScore <= 0.4) {
			$el.addClass("low");
		} else if (normalizedScore <= 0.7) {
			$el.addClass("medium");
		} else {
			$el.addClass("high");
		}
	}

	Symphonie.prototype.goToHome = function () {
		this.reset(2)
	}

	Symphonie.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset(1);
		}
	}

	Symphonie.prototype.reset = function (destinationScreen) {

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Stop currently playing sound
		this.audio.stop();

		// Go to screen and clear
		this.goToScreen(destinationScreen, $.proxy(function () {

			// Reset and clean things up
			$(".game-choices-question").removeClass("hidden");
			$(".game-choices-freedback").addClass("hidden");

			this.user.scores = {
				currentQuestionSet: "",
				currentQuestion: -1,
				score: 0,
				questionsCount: 0,
			};

		}, this));

	}

	// Expose Symphonie
	window.Symphonie = Symphonie;

})(jQuery, Promise);